<template>

        
       
 <v-container align-center>
      <v-layout row wap>
        <v-card style="min-width: 600px">
            <v-card-title primary-title>
        <div>
          <h3 class="headline">My Account</h3>
        </div>
      </v-card-title>
      <v-card-text>
          <v-form ref="form" v-on:input="clearAlerts()">
            
          <v-container fluid >
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="username"
                  label="Name"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="email"
                  label="Email"
                  disabled
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs4>
                    <v-subheader>Current Password</v-subheader>
                    </v-flex>
                <v-flex xs8>
                    <v-text-field
                    :append-icon="e1 ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (e1 = !e1)"
                    :type="e1 ? 'password' : 'text'"
                    name="input-10-0"
                    value=""
                    :rules="passwordRules"                    
                    v-model="currentPassword"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs4>
                    <v-subheader>New Password</v-subheader>
                    </v-flex>
                <v-flex xs8>
                    <v-text-field
                    :append-icon="e1 ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (e1 = !e1)"
                    :type="e1 ? 'password' : 'text'"
                    name="input-10-1"
                    hint="At least 6 characters"
                    min="8"
                    value=""
                    :rules="newPasswordRules"                    
                    v-model="newPassword"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs4>
                    <v-subheader>Confirm Password</v-subheader>
                </v-flex>
                <v-flex xs8>
                    <v-text-field
                    :append-icon="e1 ? 'visibility' : 'visibility_off'"
                    :append-icon-cb="() => (e1 = !e1)"
                    :type="e1 ? 'password' : 'text'"
                    :rules="confirmPasswordRules"
                    name="input-10-2"
                    hint="At least 6 characters"
                    min="8"
                    value=""
                    v-model="confirmPassword"
                    ></v-text-field>
                </v-flex>
            </v-layout>
          </v-container>

          </v-form>
          
        </v-card-text>
          
      <v-card-actions>
            <v-btn color="primary" @click.native="changePassword()">Update</v-btn>
          
      </v-card-actions>
        <v-alert :value="success" type="success" dismissible v-model="success">
            {{ resultMessage }}
        </v-alert>
        <v-alert :value="error" type="error" dismissible v-model="error">
            {{ errorMessage }}
        </v-alert>
        </v-card>
        
        </v-layout>
        
  </v-container>
</template>

<script>
    import { store } from '../store'
    import { putNewPassword } from '../utils/effort-tracking-api';

    export default {
    data() {
            return {
                username: "",
                userdata: [],
                email: "",
                e1: true,
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
                resultMessage: '',
                success: false,
                error: false,
                errorMessage: '',
                passwordRules: [
                    v => !!v || 'Password is required'
                ],
                newPasswordRules: [
                    v => !!v || 'New password is required'
                ],
                confirmPasswordRules: [
                    v => !!v || 'Password confirmation required',
                    v => v == this.newPassword || 'New password doesn\'t match'
                ],
            }            
        },
        methods: {
            goToAction(action){
                if(action == 'Logout') {
                    this.$store.state.usertype = '';
                    this.$store.state.userdata = null;
                    this.$store.state.classStudents = [];
                    this.$store.state.isLoggedIn = false;
                    this.$store.state.teacherClasses = [];
                    this.$store.state.token = '';
                    localStorage.removeItem('period-selected');
                    localStorage.removeItem('default-period');
                    localStorage.removeItem('active-periods');

                    window.location.href = '#/users/login';
                }
                if(action == 'Account') {
                    window.location.href = '#/account';
                }
            },

            setUserData() {
                var title = 
                typeof this.$store.state.userdata.title  != "undefined" ? this.$store.state.userdata.title : '';
                
                var user = '';
                if(this.$store.state.usertype == 'student')
                {
                    user = this.$store.state.userdata.lastName + ', ' + this.$store.state.userdata.firstName;
                } else {
                    user = title + ' '
                    + this.$store.state.userdata.firstName + ' '
                    + this.$store.state.userdata.lastName;
                }
                
                this.username = user;
                this.email = this.$store.state.userdata.email;
            },
            clearAlerts() {
                this.error = false
                this.success = false 
                this.errorMessage = ''
            },

            changePassword() {
                this.clearAlerts()
                if (this.$refs.form.validate()) {

                    var model ={
                        "User": this.email ,  
                        "CurrentPassword": this.currentPassword,
                        "NewPassword": this.newPassword };
                    
                    putNewPassword(model).then(result => {
                        if (result.status == 200) 
                        {
                            this.success = true;
                            this.resultMessage = result.data + ' . You will be redirected to the effort grading interface';
                            this.newPassword = this.currentPassword = this.confirmPassword = '';
                            this.passwordRules = this.newPasswordRules = this.confirmPasswordRules = [];
                            setTimeout(() => { window.location.href = '#/home'; }, 5000)
                            
                        } else {
                            this.error = true;
                            if (result.response.status == 400) {
                                this.errorMessage = result.response.data;
                                if (this.errorMessage.length < 5)
                                    this.errorMessage = 'Something went wrong, please review your current password and try again.';    
                            }
                            else {
                                this.errorMessage = `Something went wrong, (${result.response.status})`;    
                            }
                        }
                    }).catch( ex => {
                        this.error = true;
                        this.errorMessage = 'Something went wrong, please try again';
                    });
                }
            }
        },
        mounted() {            
            this.userdata = this.$store.state.userdata;
            if(this.userdata != null) {
                this.setUserData();
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/MyAccount.vue